import { BCDataGrid } from '../../BCDataGrid';

export function calculateOptionColumnsCellValue(
	this: BCDataGrid.Entities.IColumnProps,
	{ selectedOptionKey }
) {
	return selectedOptionKey === this.name;
}
